import { useMediaQuery } from "react-responsive";
import { UI } from "../config/ui";

export const useResponsive = () => {
  const isDesktop = useMediaQuery({
    query: "(min-width: " + UI.sm + "px)",
  });
  const isTabletLg = useMediaQuery({
    query: "(min-width: " + UI.lg + "px)",
  });
  return {
    isDesktop,
    isTabletLg,
  };
};
